import { render, staticRenderFns } from "./queueManage.vue?vue&type=template&id=11ffb7f6&scoped=true"
import script from "./queueManage.vue?vue&type=script&lang=ts"
export * from "./queueManage.vue?vue&type=script&lang=ts"
import style0 from "./queueManage.vue?vue&type=style&index=0&id=11ffb7f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11ffb7f6",
  null
  
)

export default component.exports